<div class="claims-overview">
    <div class="claims-overview__head">
        <div class="claims-overview__title">
            <h2>Schadestatus</h2>
        </div>
        <div class="claims-overview__btn">
            <button class="btn btn--secondary" (click)="onReportClaim()">Meld schade online</button>
        </div>
    </div>

    <div class="claims-overview__result" *ngIf="loaded; else loading">
        <!-- Geen schademeldingen-->
        <div class="claims-overview__empty" *ngIf="allClaims.length < 1">
            <h3>Gefeliciteerd!</h3>
            <p>
                Uw schademap is leeg. Dat betekent dat u geen hangende, lopende of gesloten schademeldingen heeft of
                misschien zelfs nog nooit brokken heeft gemaakt. Dat zien wij, net als u, natuurlijk graag.
            </p>
            <div class="claims-overview__image">
                <img
                    lazyLoad="{{
                        baseUrl
                    }}/assets/images/01_algemeen/04_salesfunnel/01_bedankt/bedankt-taart-310x220.png"
                    alt="Gefeliciteerd! Uw schademap is leeg"
                />
            </div>
        </div>

        <!-- Pending claims -->
        <div class="claims-overview__files" *ngIf="unfinished.length > 0">
            <h2>Schademelding afronden</h2>
            <ng-container *ngFor="let dossier of unfinished">
                <ins-pending-claim-item class="mijn-schades__dossier" [dossier]="dossier"></ins-pending-claim-item>
            </ng-container>
        </div>

        <!-- Claims items -->
        <div class="claims-overview__files" *ngIf="open.length > 0" id="lopende-dossiers">
            <h2>Lopende schadeclaims</h2>
            <div class="claims-overview__list">
                <ng-container *ngFor="let dossier of open; let count = index">
                    <ins-claim-item
                        class="claims-overview__files"
                        [dossier]="dossier"
                        [ngClass]="{ 'claims-overview__files--hide': openClaims ? false : count >= 2 }"
                    ></ins-claim-item>
                </ng-container>
            </div>
            <div class="claims-overview__buttons" *ngIf="open.length > 2">
                <button class="btn btn--link" (click)="showHideOpenClaims()">
                    <span *ngIf="openClaims">
                        Verberg alle lopende schadeclaims
                        <ins-more-indicator [up]="true"></ins-more-indicator>
                    </span>
                    <span *ngIf="!openClaims">
                        Bekijk alle lopende schadeclaims
                        <ins-more-indicator [down]="true"></ins-more-indicator>
                    </span>
                </button>
            </div>
        </div>

        <!-- Claim items -->
        <div class="claims-overview__files" *ngIf="files.length > 0" id="gesloten-dossiers">
            <h2>Gesloten schadeclaims</h2>
            <div class="claims-overview__list">
                <ng-container *ngFor="let dossier of files; let count = index">
                    <ins-claim-item
                        class="claims-overview__files"
                        [dossier]="dossier"
                        [ngClass]="{ 'claims-overview__files--hide': closedClaims ? false : count >= 2 }"
                    ></ins-claim-item>
                </ng-container>
            </div>
            <div class="claims-overview__buttons" *ngIf="files.length > 2">
                <button class="btn btn--link" (click)="showHideClosedClaims()">
                    <span *ngIf="closedClaims">
                        Verberg alle gesloten schadeclaims
                        <ins-more-indicator [up]="true"></ins-more-indicator>
                    </span>
                    <span *ngIf="!closedClaims">
                        Bekijk alle gesloten schadeclaims
                        <ins-more-indicator [down]="true"></ins-more-indicator>
                    </span>
                </button>
            </div>
        </div>
    </div>

    <ng-template #loading>
        <div class="skeleton-loader__line skeleton-loader__line--half no-float"></div>
        <div class="skeleton-loader__line no-float"></div>
        <div class="skeleton-loader__line no-float"></div>
        <div class="skeleton-loader__line skeleton-loader__line--half no-float"></div>
        <div class="skeleton-loader__line no-float"></div>
        <div class="skeleton-loader__line no-float"></div>
    </ng-template>

    <ins-claims-overview-content></ins-claims-overview-content>
</div>
